<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconEmoji_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM8.071 8.429a1.786 1.786 0 1 1 0 3.572 1.786 1.786 0 0 1 0-3.572Zm9.192 7.825c-.059.133-1.501 3.246-5.263 3.246s-5.204-3.113-5.263-3.246a1.073 1.073 0 0 1 1.956-.878c.033.074.956 1.981 3.307 1.981 2.391 0 3.299-1.961 3.308-1.981.243-.541.879-.78 1.417-.539.54.244.78.878.538 1.417ZM15.929 12a1.786 1.786 0 1 1 0-3.572 1.786 1.786 0 0 1 0 3.572Z"
    />
</svg>
